import { render } from "./AddTermForm.vue?vue&type=template&id=5149897e&scoped=true"
import script from "./AddTermForm.vue?vue&type=script&lang=js"
export * from "./AddTermForm.vue?vue&type=script&lang=js"

import "./AddTermForm.vue?vue&type=style&index=0&id=5149897e&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-5149897e"

export default script